/*
*@Author: dcl
*@Description: 互联网保险产品
*@Date: 2022-11-14 11:30:12
*/

<template>
    <div class="isu">
        <el-table :data="companyList" height="20rem" :header-cell-style="headerstyle" :cell-style="cellStyle"
            style="width: 95%">
            <el-table-column prop="platform" label="自营平台" min-width="120" align="center"></el-table-column>
            <el-table-column prop="name" label="产品名称" min-width="120" align="center"></el-table-column>
            <el-table-column prop="beianname" label="条款名称" min-width="200" align="center">
                <template slot-scope="scope">
                    <a v-if="scope.row.name === '机动车交通事故责任强制保险'" target="_blank"
                        href="/static/pdf/机动车交通事故责任强制保险条款.pdf">{{ scope.row.beianname }}</a>
                    <a v-else-if="scope.row.name === '机动车商业保险'" target="_blank"
                        href="/static/pdf/中国保险行业协会机动车商业保险示范条款（2020 版）.pdf">{{ scope.row.beianname }}</a>
                    <a v-else-if="scope.row.name === '新能源汽车商业保险'" target="_blank"
                        href="/static/pdf/中国保险行业协会新能源汽车商业保险示范条款（试行）.pdf">{{ scope.row.beianname }}</a>
                    <a v-else target="_blank" :href="'/static/pdf/' + scope.row.beianname + '.pdf'">{{
            scope.row.beianname
                        }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="beian" label="备案编号/批复文号" min-width="120" align="center"></el-table-column>
            <el-table-column prop="chengbao" label="承保公司" min-width="120" align="center"></el-table-column>
        </el-table>
        <div class="isu-txt">
            <div>
                经营互联网保险业务的网站地址登陆中国保险行业协会网址:
                <a
                    href="http://icidp.iachina.cn/ICID/">http://icidp.iachina.cn/ICID/</a>.&nbsp;&nbsp;(在“行业信息披露”行中输入“东风南方保险代理”关键字搜索查阅)
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyList: [{
            //     platform: "www.elongai.com",
            //     name: "机动车交通事故责任强制保险",
            //     beianname: "机动车交通事故责任强制保险条款",
            //     beian: "银保监复[2020]610号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加法定节假日限额翻倍险（BX20111209）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 246号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加车上货物责任险（BX20111207）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 248号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "驾乘人员意外伤害保险示范条款（2020版）附加住院津贴保险（BX20115201）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 253号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加精神损害抚慰金责任险（BX20111208）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 254号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加新增加设备损失险（BX20111203）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 255号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加医保外医疗费用责任险（BX20111210）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 256号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加机动车增值服务特约条款（BX20111211）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 257号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加发动机进水损坏除外特约条款（BX20111206）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 258号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加车身划痕损失险（BX20111204）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 263号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加绝对免赔率特约条款（BX20111201）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 265号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加车轮单独损失险（BX20111202）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 268号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "驾乘人员意外伤害保险示范条款（2020版）附加医保外医疗费用补偿险（BX20115202）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 269号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）附加修理期间费用补偿险（BX20111205）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(附) 274号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）机动车损失保险（BX20111101）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(主) 148号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）机动车第三者责任保险（BX20111102）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(主) 152号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "驾乘人员意外伤害保险示范条款（2020版）驾乘人员意外伤害保险（BX20115101）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(主) 157号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "机动车商业保险",
            //     beianname: "机动车商业保险示范条款（2020版）机动车车上人员责任保险（BX20111103）",
            //     beian: "(人保财险)(备-机动车辆保险)【2020】(主) 160号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加车轮单独损失险（NEV21111205）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 822号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加法定节假日限额翻倍险（NEV21111211）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 823号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车驾乘人员意外伤害保险示范条款（试行）附加住院津贴保险（NEV21112201）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 824号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加新能源汽车增值服务特约条款（NEV21111213）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 825号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加修理期间费用补偿险（NEV21111208）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 826号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加车上货物责任险（NEV21111209）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 827号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加自用充电桩责任保险（NEV21111203）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 828号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加外部电网故障损失险（NEV21111201）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 829号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加精神损害抚慰金责任险（NEV21111210）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 830号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加新增加设备损失险（NEV21111206）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 831号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加医保外医疗费用责任险（NEV21111212）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 832号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车驾乘人员意外伤害保险示范条款（试行）附加医保外医疗费用补偿险（NEV21112202）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 833号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加自用充电桩损失保险（NEV21111202）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 834号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加绝对免赔率特约条款（NEV21111204）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 835号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）附加车身划痕损失险（NEV21111207）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(附) 836号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车驾乘人员意外伤害保险示范条款（试行）驾乘人员意外伤害保险（NEV21112101）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(主) 234号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）新能源汽车车上人员责任保险（NEV21111103）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(主) 235号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）新能源汽车损失保险（NEV21111101）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(主) 236号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
            //     platform: "www.elongai.com",
            //     name: "新能源汽车商业保险",
            //     beianname: "新能源汽车商业保险示范条款（试行）新能源汽车第三者责任保险（NEV21111102）",
            //     beian: "(人保财险)(备-机动车辆保险)【2021】(主) 237号",
            //     chengbao: "中国人民财产保险股份有限公司"
            // },
            // {
                platform: "www.elongai.cn",
                name: "机动车交通事故责任强制保险",
                beianname: "机动车交通事故责任强制保险",
                beian: "银保监复〔2020〕617 号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）机动车损失保险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(主) 122号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）机动车第三者责任保险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(主) 127号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）机动车车上人员责任保险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(主) 126号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加绝对免赔率特约条款",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 960号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加车轮单独损失险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 948号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加新增加设备损失险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 970号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加车身划痕损失险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 963号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加修理期间费用补偿险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 956号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加发动机进水损坏除外特约条款",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 955号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加车上货物责任险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 973号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加精神损害抚慰金责任险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 969号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加法定节假日限额翻倍险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 967号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加医保外医疗费用责任险",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 965号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车商业保险",
                beianname: "中国平安财产保险股份有限公司机动车商业保险示范条款（2020版）附加机动车增值服务特约条款",
                beian: "(平安财险)(备-机动车辆保险)【2020】(附) 972号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车损失保险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(主) 143号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车第三者责任保险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(主) 140号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车车上人员责任保险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(主) 142号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加外部电网故障损失险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 148号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加自用充电桩损失保险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 146号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加自用充电桩责任保险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 149号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加绝对免赔率特约条款",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 139号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车轮单独损失险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 138号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加新增加设备损失险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 151号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车身划痕损失险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 141号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加修理期间费用补偿险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 142号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车上货物责任险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 143号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加精神损害抚慰金责任险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 150号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加法定节假日限额翻倍险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 140号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加医保外医疗费用责任险",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 152号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "新能源汽车商业保险",
                beianname: "中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加新能源汽车增值服务特约条款",
                beian: "(平安财险)(备-机动车辆保险)【2021】(附) 144号",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "平安产品质量保证保险",
                beianname: "平安产品质量保证保险",
                beian: "H00001731412017050452271",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "平安产险售后服务代用品费用赔偿责任保险",
                beianname: "平安产险售后服务代用品费用赔偿责任保险条款",
                beian: "C00001730912020092502862",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "平安产品置换责任保险",
                beianname: "平安产品置换责任保险条款",
                beian: "C00001730912019122730092",
                chengbao: "中国平安财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "机动车交通事故责任强制保险条款",
                beianname: "机动车交通事故责任强制保险条款 ",
                beian: "银保监复【2020】611号",
                chengbao: "中国大地财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "中国大地财产保险股份有限公司商业险保险示范条款（2020版）",
                beianname: "机动车商业条款",
                beian: "(中国大地保险)(备-机动车辆保险)【2020】",
                chengbao: "中国大地财产保险股份有限公司"
            },
            {
                platform: "www.elongai.cn",
                name: "中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）",
                beianname: "中国保险行业协会新能源汽车商业保险示范条款（试行） ",
                beian: "(中国大地保险)(备-机动车辆保险)【2021】",
                chengbao: "中国大地财产保险股份有限公司"
            }]
        };
    },
    methods: {
        headerstyle() {
            return "font-size: .67rem;font-weight: normal;background-color:#FAFAFA;color: #666666;";
        },
        cellStyle() {
            return "font-size: 0.53rem;color: #666666;";
        }
    }
};
</script>

<style lang="less" scoped>
.isu {
    margin: .73rem 0 4rem;

    .isu-txt {
        margin-top: .33rem;
        font-size: .67rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Informationmobile/support.vue